/**
 * TanStack Query hooks for `public-trust-center-with-auditor-attestation`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publicTrustCenterWithAuditorAttestationQueryKeys,
	type CreatePublicTrustCenterWithAuditorAttestationBody,
	type ListPublicTrustCenterWithAuditorAttestationResponse,
	type PublicTrustCenterWithAuditorAttestationRow,
} from "./api";

export function usePublicTrustCenterWithAuditorAttestationList(): UseQueryResult<ListPublicTrustCenterWithAuditorAttestationResponse, Error> {
	return useQuery({
		queryKey: publicTrustCenterWithAuditorAttestationQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublicTrustCenterWithAuditorAttestationCreate(): UseMutationResult<PublicTrustCenterWithAuditorAttestationRow, Error, CreatePublicTrustCenterWithAuditorAttestationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publicTrustCenterWithAuditorAttestationQueryKeys.all });
		},
	});
}

export function usePublicTrustCenterWithAuditorAttestationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publicTrustCenterWithAuditorAttestationQueryKeys.all });
		},
	});
}
